export default __webpack_public_path__ + "static/936-f7d4ab92a88c683bcfa65453a08e7b11.gif";